(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Custom Block Loader
 *
 * Initializes sandboxed iframes for custom blocks.
 * Uses fresh published srcdoc from the server when available so stale page cache
 * does not keep an outdated iframe payload on the frontend.
 */
(function () {
  'use strict';

  var TIMEOUT_MS = 8000;
  var loaderConfig = window.CUSTOM_BLOCK_LOADER || {};
  var prerenderActionsBound = false;

  function bootstrap() {
    var blocks = document.querySelectorAll('.custom-block[data-block-id]');
    if (!blocks.length) return;
    bindPrerenderActions();

    for (var i = 0; i < blocks.length; i++) {
      initBlock(blocks[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  window.addEventListener('load', bootstrap);

  function initBlock(container) {
    if (container.dataset.cbInitialized) return;
    container.dataset.cbInitialized = '1';
    var prerender = container.querySelector('.custom-block__prerender');
    resolveRuntimeData(container).then(function (runtime) {
      var srcdoc = runtime && runtime.srcdoc ? runtime.srcdoc : getFallbackSrcdoc(container);
      if (!srcdoc || !srcdoc.trim()) return;
      var sandbox = runtime && runtime.sandbox ? runtime.sandbox : container.dataset.sandbox || 'allow-scripts';
      var minHeight = runtime && runtime.min_height ? parseInt(runtime.min_height, 10) : parseInt(container.style.minHeight, 10) || 400;

      if (runtime && runtime.version) {
        container.dataset.blockVersion = String(runtime.version);
      }

      initIframe(container, prerender, sandbox, minHeight, srcdoc);
    })["catch"](function () {
      var fallbackSrcdoc = getFallbackSrcdoc(container);
      if (!fallbackSrcdoc || !fallbackSrcdoc.trim()) return;
      initIframe(container, prerender, container.dataset.sandbox || 'allow-scripts', parseInt(container.style.minHeight, 10) || 400, fallbackSrcdoc);
    });
  }

  function initIframe(container, prerender, sandbox, minHeight, srcdoc) {
    var tmpl = container.querySelector('.custom-block__srcdoc');
    if (!tmpl && !srcdoc) return;
    var iframe;
    var loaded = false;

    function onMessage(e) {
      if (!iframe || e.source !== iframe.contentWindow) return;
      if (!e.data || _typeof(e.data) !== 'object') return;

      if (e.data.type === 'cb-ready') {
        loaded = true;
        clearTimeout(timer);
        showIframe();
      }

      if (e.data.type === 'cb-height' && typeof e.data.height === 'number') {
        iframe.style.height = e.data.height + 'px';
      }

      if (e.data.type === 'cb-error') {
        reportIframeError(e.data.error);
      }

      if (e.data.type === 'cb-action') {
        handleAction(e.data);
      }
    }

    window.addEventListener('message', onMessage);
    var iframe = document.createElement('iframe');
    iframe.className = 'custom-block__frame';
    iframe.setAttribute('sandbox', sandbox);
    iframe.style.width = '100%';
    iframe.style.border = 'none';
    iframe.style.display = 'none';
    iframe.style.height = (minHeight || 400) + 'px';
    iframe.setAttribute('title', 'Custom block');
    iframe.srcdoc = srcdoc;
    iframe.addEventListener('load', function () {
      loaded = true;
      clearTimeout(timer);
      showIframe();
    });
    container.appendChild(iframe);
    var timer = setTimeout(function () {
      if (!loaded) {
        reportIframeError('Iframe load timeout');
      }
    }, TIMEOUT_MS);

    function showIframe() {
      iframe.style.display = 'block';
      if (prerender) prerender.style.display = 'none';
    }
  }

  function resolveRuntimeData(container) {
    var blockId = parseInt(container.dataset.blockId, 10) || 0;

    if (blockId <= 0 || !loaderConfig.ajaxUrl || !loaderConfig.action || typeof window.fetch !== 'function') {
      return Promise.resolve(null);
    }

    var requestUrl = loaderConfig.ajaxUrl + '?action=' + encodeURIComponent(loaderConfig.action) + '&block_id=' + encodeURIComponent(String(blockId));
    return window.fetch(requestUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        return null;
      }

      return response.json()["catch"](function () {
        return null;
      });
    }).then(function (payload) {
      if (!payload || !payload.success || !payload.data || !payload.data.srcdoc) {
        return null;
      }

      return payload.data;
    })["catch"](function () {
      return null;
    });
  }

  function getFallbackSrcdoc(container) {
    var tmpl = container.querySelector('.custom-block__srcdoc');
    if (!tmpl) return '';
    var escaped = tmpl.innerHTML || '';
    if (!escaped.trim()) return '';
    return decodeHTMLEntities(escaped);
  }

  function handleAction(data) {
    if (!data || _typeof(data) !== 'object') return;

    if (data.action === 'link') {
      var url = sanitizeUrl(data.url);
      if (!url) return;
      navigateToUrl(url, data.target);
      return;
    }

    if (data.action === 'form') {
      openTemplateForm(data.formId);
    }
  }

  function bindPrerenderActions() {
    if (prerenderActionsBound) return;
    prerenderActionsBound = true;
    document.addEventListener('click', function (event) {
      var target = event.target;
      var actionEl = target && target.closest ? target.closest('.custom-block .custom-block__prerender [data-cb-action]') : null;
      if (!actionEl) return;
      event.preventDefault();
      event.stopPropagation();
      handleAction({
        action: actionEl.getAttribute('data-cb-action') || '',
        url: actionEl.getAttribute('data-cb-url') || '',
        target: actionEl.getAttribute('data-cb-target') || '_self',
        formId: actionEl.getAttribute('data-cb-form-id') || ''
      });
    }, true);
  }

  function sanitizeUrl(rawUrl) {
    if (typeof rawUrl !== 'string') return '';
    var url = rawUrl.trim();
    if (!url) return '';
    var lower = url.toLowerCase();

    if (lower.indexOf('javascript:') === 0 || lower.indexOf('vbscript:') === 0 || lower.indexOf('data:') === 0) {
      return '';
    }

    if (url.charAt(0) === '/' || url.charAt(0) === '#' || lower.indexOf('http://') === 0 || lower.indexOf('https://') === 0 || lower.indexOf('mailto:') === 0 || lower.indexOf('tel:') === 0) {
      return url;
    }

    return '';
  }

  function navigateToUrl(url, target) {
    var resolvedUrl = resolveUrl(url);
    if (!resolvedUrl) return;

    if (target === '_blank' && url.charAt(0) === '#') {
      window.location.assign(resolvedUrl);
      return;
    }

    if (target === '_blank') {
      var link = document.createElement('a');
      link.href = resolvedUrl;
      link.target = '_blank';
      link.rel = 'noopener';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    window.location.assign(resolvedUrl);
  }

  function reportIframeError(errorMessage) {
    if (typeof window.console !== 'undefined' && typeof window.console.error === 'function') {
      window.console.error('[CustomBlock]', errorMessage || 'Unknown iframe error');
    }
  }

  function resolveUrl(url) {
    try {
      return new URL(url, window.location.href).toString();
    } catch (e) {
      return '';
    }
  }

  function openTemplateForm(formId) {
    if (typeof formId !== 'string' || !formId.trim()) return;
    var normalizedId = formId.replace(/^#/, '').trim();
    if (!normalizedId) return;
    var modal = document.querySelector('[data-modal="' + normalizedId + '"]') || document.getElementById(normalizedId);

    if (typeof window.serverspaceOpenModal === 'function') {
      try {
        window.serverspaceOpenModal(normalizedId);
        return;
      } catch (e) {// Fall through to DOM-based fallback if host modal helper fails.
      }
    }

    if (!modal) return;
    modal.classList.add('show');
    document.body.classList.add('modal-open');
  }

  function decodeHTMLEntities(str) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }
})();

},{}]},{},[1]);
